import React from 'react';

export default function Privacy() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">

                    <h1 className="mb-4 text-center">Privacy Policy</h1>
                    {/*<p className="text-muted text-center">Last updated: August 21, 2025</p>*/}

                    <div className="mb-4">
                        <h2>1. Introduction</h2>
                        <p>
                            Nectr Studio is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>2. Information We Collect</h2>
                        <ul>
                            <li><strong>Personal Info:</strong> Name, email, messages sent through our forms.</li>
                            <li><strong>Usage Data:</strong> Info about how you use our site (via cookies, analytics).</li>
                        </ul>
                    </div>

                    <div className="mb-4">
                        <h2>3. How We Use Your Info</h2>
                        <ul>
                            <li>To respond to messages or requests</li>
                            <li>To improve our website and services</li>
                            <li>To send updates (only if you opt in)</li>
                        </ul>
                    </div>

                    <div className="mb-4">
                        <h2>4. Third-Party Services</h2>
                        <p>We may use tools like analytics or payment processors, each with their own privacy policies.</p>
                    </div>

                    <div className="mb-4">
                        <h2>5. Data Security</h2>
                        <p>We take reasonable steps to protect your data, but no method is 100% secure.</p>
                    </div>

                    <div className="mb-4">
                        <h2>6. Your Rights</h2>
                        <p>Contact us at <a href="mailto:support@nectrstudio.com">support@nectrstudio.com</a> to access or delete your info.</p>
                    </div>

                    <div className="mb-4">
                        <h2>7. Changes</h2>
                        <p>We may update this policy from time to time. The most recent version will always be posted here.</p>
                    </div>

                    <div className="mb-4">
                        <h2>8. Contact</h2>
                        <p>Have questions? Email us at <a href="mailto:support@nectrstudio.com">support@nectrstudio.com</a>.</p>
                    </div>

                </div>
            </div>
        </div>
    );
}
